import { getEnvConfig } from '@hbs-us/contracts';

import { getAppEnv } from '../../lib/env.js';

/**
 * Build the credentialed URLs for the payroll PDF + CSV exports (D-06 / T-22-export). The api host is
 * NEVER hardcoded — it comes from `@hbs-us/contracts` `getEnvConfig().domains.api` (the same source
 * apiFetch uses). Both exports are generated by the EXISTING server engines (generatePayrollPdf +
 * buildPayrollCsv, reused from the SSR payroll route) — the SPA only links out; it never rebuilds the
 * PDF/CSV client-side.
 *
 * Opened via `<a>` / new tab with the user's cookies (a safe GET read, no CSRF). The endpoints are
 * tenant-scoped server-side (SEC-11), so the links carry only the locked run id.
 */

function apiBaseUrl(): string {
  return `https://${getEnvConfig(getAppEnv()).domains.api}`;
}

/** Credentialed payroll PDF download for a locked run (api-host GET, reused engine). */
export function payrollPdfUrl(runId: number): string {
  return `${apiBaseUrl()}/api/v1/payroll/runs/${runId}/pdf`;
}

/** Credentialed payroll CSV download for a locked run (api-host GET, reused builder). */
export function payrollCsvUrl(runId: number): string {
  return `${apiBaseUrl()}/api/v1/payroll/runs/${runId}/csv`;
}
